import { WebUserGroup } from "@robe/core-types";
import { parseQueryParamsObject } from "@robe/core-utils";
import { XcoreCore } from "XcoreCore";

export class RobeSupportFilesGroups {
  private core: XcoreCore;

  constructor(core: XcoreCore) {
    this.core = core;
  }

  public list(params: string) {
    return this.core.fetch("/api/web/groups" + params).then<WebUserGroup[]>((r) => r.json());
  }

  public single(id: number) {
    return this.core.fetch(`/api/web/groups/${id}`).then<WebUserGroup>((r) => r.json());
  }

  public delete(groups: number[]) {
    return this.core.fetch(`/api/web/groups${parseQueryParamsObject({ ids: groups })}`, { method: "DELETE" });
  }

  public rename(id: number, name: string) {
    return this.core.fetch("/api/web/groups", { method: "PUT", body: JSON.stringify({ id, name }) });
  }

  public create(name: string) {
    return this.core.fetch("/api/web/groups", { method: "POST", body: JSON.stringify({ name }) });
  }
}
